// extracted by mini-css-extract-plugin
module.exports = {"CardContent":"StationCard_CardContent__3zgA3","Table":"StationCard_Table__2Q2HL","Hint":"StationCard_Hint__3yvQq"};